"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spec = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const openapi_1 = require("../../../openapi");
const Dealer = __importStar(require("./schema"));
exports.NAMESPACE = 'Culligan.Api.V1.Frontend.Dealer.Spec';
const SearchResponse = openapi_1.Response.Success(Dealer.SearchResult).annotations({
    description: 'Dealer locations that match the search',
});
const searchLocations = platform_1.HttpApiEndpoint.get('searchLocations') `/location/search`
    .setUrlParams(Dealer.SearchQuery)
    .addSuccess(SearchResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Search Dealer Locations')
    .annotate(platform_1.OpenApi.Description, 'Searches dealer locations. code, name, contactPersonName and email match as a substring, ignoring case, after every character that is not an ASCII letter or digit (A-Z, a-z, 0-9) is removed from the search term, accented letters included. So "St. Louis" never matches a stored "St. Louis", and "Société" is searched as "socit". country must match exactly, ignoring case. All given filters apply together. A filter sent as an empty string is ignored. A one-character code, name, contactPersonName or email is a 422 with the field errors. That length is checked before the cleaning, so "a." searches for "a", and a term made only of other characters, such as "--", becomes empty and matches every location that has a value in that field (an empty email or contact person name is stored as null and does not match). With no filters, every stored location is returned; there is no role or ownership scoping.')
    .middleware(openapi_1.Security.V1AuthenticatedUser)
    .pipe(openapi_1.Error.withV1StandardErrors);
exports.Spec = platform_1.HttpApiGroup.make('v1.frontend.dealer')
    .add(searchLocations)
    .prefix('/dealer')
    .annotate(platform_1.OpenApi.Title, 'Dealer')
    .annotate(platform_1.OpenApi.Description, 'Dealer location search for authenticated users')
    .pipe(openapi_1.Audience.withAudiences(openapi_1.Audience.Audience.User));
//# sourceMappingURL=spec.js.map